import styles from './font.css';
import withStyles from 'isomorphic-style-loader/withStyles';

export const Fonts = withStyles(styles)(() => null);
